import React, { useState } from 'react';
import { request } from '@shakkerai/services';
import { modelTypeMap } from '../../../../constants';
import { setModelsModalState } from '../../../../store/state';
import { v4 } from 'uuid';
import { useAsyncEffect } from 'ahooks';

export const useFetchList = (modelType) => {
  const [loading, setLoading] = useState(false);
  useAsyncEffect(async () => {
    getHistoryData({
      modelType: modelTypeMap[modelType],
      page: 1, // 翻页不生效
      pageSize: 100,
      requestId: v4(),
      baseTypes: ['19'],
    });
  }, []);

  const getHistoryData = async (params) => {
    setLoading(true);
    try {
      const res = await request('/gateway/sd-api/gen/tool/model/used/history', params);
      if (res.code === 0) {
        setModelsModalState({
          historyModels: res.data.list,
        });
      } else {
        console.log('接口异常');
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  return { loading };
};
